import { render } from "./TheAlert.vue?vue&type=template&id=a40ca54a&scoped=true&ts=true&lang=html"
import script from "./TheAlert.vue?vue&type=script&lang=ts"
export * from "./TheAlert.vue?vue&type=script&lang=ts"

import "./TheAlert.vue?vue&type=style&index=0&id=a40ca54a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a40ca54a"]])

export default __exports__